<template>
  <div class="user-visits-sector-page">
    <img src="../assets/face logo.png">
    <div class="title">
      EXIT
    </div>
    <div>
      <q-r-code-scanner @codeScanned="onCodeScanned"/>
    </div>

    <div class="notifications-container">
      <notifications group="user-visits" />
    </div>

  </div>
</template>

<script>
  import QRCodeScanner from "../components/QRCodeScanner";
  import {endUserVisit} from "../services/graphql";

  export default {
    name: "UserVisitExitPage",
    components: {QRCodeScanner},
    methods: {
      onCodeScanned(content) {
        try {
          let user = JSON.parse(content);
          endUserVisit(user.phone)
          .then(() => {
            this.$notify({
              group: 'user-visits',
              title: 'Der Benutzerbesuch wurde erfolgreich beendet',
              duration: 10000
            });
          }).catch(err => {
            if (
              err.graphQLErrors &&
              err.graphQLErrors.length
            ) {
              this.$notify({
                group: 'user-visits',
                title: err.graphQLErrors[0].message,
                duration: -1,
                type: 'warn'
              });
            }
          })
        } catch (e) {
          this.$notify({
            group: 'user-visits',
            title: 'Ungültiger Code',
            duration: 2000,
            type: 'warn'
          });
        }
      }
    }
  }
</script>

<style lang="scss">
  @import "UserVisitsSectorPage";
</style>
